<template>
    <div class="scr-body">
        <carousel>
            <slide>Slide 1 Content</slide>
            <slide>Slide 2 Content</slide>
            <slide>Slide 1 Content</slide>
            <slide>Slide 2 Content</slide>
            <slide>Slide 1 Content</slide>
            <slide>Slide 2 Content</slide>
        </carousel>
    </div>
</template>

<script>
//This component is showing information about DTC. *Might get removed.*
export default {
    name: "About",
    created() {
        // Fired when the component is ready. <br/> Emitted for the Header to be changed to the correct title.
        // @arg The argument is a `String` value representing the current title.
        this.$emit("changed", "About DTC");
    }
};
</script>

<style>
</style>